// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import crmEntity from './entities/crm.json';
import crmMenu from '../pages/crm/menu.json';
import crmFullForm from '../pages/crm/forms/full.json';
import crmContextForm from '../pages/crm/forms/context.json';
import crmMiniForm from '../pages/crm/forms/mini.json';
import crmLookupForm from '../pages/crm/forms/lookup.json';
import crmTableView from '../pages/crm/views/table.json';
import crmStagesView from '../pages/crm/views/stages.json';
import crmCardsView from '../pages/crm/views/cards.json';
import crmSplitView from '../pages/crm/views/split.json';
import crmCalendarView from '../pages/crm/views/calendar.json';
import crmDashboardView from '../pages/crm/views/dashboard.json';

/** Тип запису «Контакт» зі сторінками пакета: меню, форми та подання з pages/crm/. */
export const crmDefinition: IRecordTypeDefinition = {
  ...crmEntity,
  views: assembleViewSet({
      table: crmTableView,
      stages: crmStagesView,
      cards: crmCardsView,
      split: crmSplitView,
      calendar: crmCalendarView,
      dashboard: crmDashboardView,
  }),
  form: crmFullForm,
  forms: { full: crmFullForm, context: crmContextForm, mini: crmMiniForm, lookup: crmLookupForm },
  menu: crmMenu,
} as IRecordTypeDefinition;
